function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#0066FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.29803 7.8796L8.13203 9.3468C8.20633 9.4063 8.29456 9.45351 8.39168 9.48572C8.4888 9.51793 8.5929 9.5345 8.69803 9.5345C8.80316 9.5345 8.90727 9.51793 9.00438 9.48572C9.1015 9.45351 9.18973 9.4063 9.26403 9.3468L11.098 7.8796L12.932 9.3468C13.0063 9.4063 13.0946 9.45351 13.1917 9.48572C13.2888 9.51793 13.3929 9.5345 13.498 9.5345C13.6032 9.5345 13.7073 9.51793 13.8044 9.48572C13.9015 9.45351 13.9897 9.4063 14.064 9.3468L16.464 7.4268L15.332 6.5212L13.498 7.9884L11.664 6.5212C11.5897 6.46169 11.5015 6.41449 11.4044 6.38228C11.3073 6.35007 11.2032 6.3335 11.098 6.3335C10.9929 6.3335 10.8888 6.35007 10.7917 6.38228C10.6946 6.41449 10.6063 6.46169 10.532 6.5212L8.69803 7.9884L6.86403 6.5212C6.78973 6.46169 6.7015 6.41449 6.60438 6.38228C6.50727 6.35007 6.40316 6.3335 6.29803 6.3335C6.1929 6.3335 6.0888 6.35007 5.99168 6.38228C5.89456 6.41449 5.80633 6.46169 5.73203 6.5212L3.33203 8.4412L4.46403 9.3468L6.29803 7.8796Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.498 11.8282L11.664 10.361C11.5897 10.3015 11.5015 10.2543 11.4044 10.2221C11.3073 10.1899 11.2032 10.1733 11.098 10.1733C10.9929 10.1733 10.8888 10.1899 10.7917 10.2221C10.6946 10.2543 10.6063 10.3015 10.532 10.361L8.69803 11.8282L6.86403 10.361C6.78973 10.3015 6.7015 10.2543 6.60438 10.2221C6.50727 10.1899 6.40316 10.1733 6.29803 10.1733C6.1929 10.1733 6.0888 10.1899 5.99168 10.2221C5.89456 10.2543 5.80633 10.3015 5.73203 10.361L3.33203 12.281L4.46403 13.1866L6.29803 11.7194L8.13203 13.1866C8.20633 13.2461 8.29456 13.2934 8.39168 13.3256C8.4888 13.3578 8.5929 13.3743 8.69803 13.3743C8.80316 13.3743 8.90727 13.3578 9.00438 13.3256C9.1015 13.2934 9.18973 13.2461 9.26403 13.1866L11.098 11.7194L12.932 13.1866C13.0063 13.2461 13.0946 13.2934 13.1917 13.3256C13.2888 13.3578 13.3929 13.3743 13.498 13.3743C13.6032 13.3743 13.7073 13.3578 13.8044 13.3256C13.9015 13.2934 13.9897 13.2461 14.064 13.1866L16.464 11.2666L15.332 10.361L13.498 11.8282Z",
  fill: "white"
});

const SvgS3Datalake = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgS3Datalake, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/s3_datalake.93d774a7.svg";
export { ForwardRef as ReactComponent };